import React from "react";

const Sticky = () => {
  return (
    <section
      style={{ position: "fixed", bottom: "0px", zIndex: "999" }}
      className="desk-view container-full"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100vw",
          height: "60px",
        }}
      >
        <div style={{ width: "25%" }}>
          <a
            href="https://maps.app.goo.gl/DF2oQ9m3fA97fYCW6"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              paddingTop: "10px",
              gap: "10px",
              textDecoration: "none",
              backgroundColor: "#944f9f",
            }}
          >
            <img
              src="/photo/google-maps (1).svg"
              alt=""
              height="25px"
              width="25px"
            />
            <p style={{ fontSize: "12px", color: "white", fontWeight: 600 }}>
              LOCATE US
            </p>
          </a>
        </div>

        <div style={{ width: "25%" }}>
          <a
            href="https://wa.link/oyfae2"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              textDecoration: "none",
              paddingTop: "10px",
              gap: "10px",
              backgroundColor: "#30327d",
            }}
          >
            <img
              src="/photo/whatsapp (1).svg"
              alt=""
              height="25px"
              width="25px"
            />
            <p style={{ fontSize: "12px", color: "white", fontWeight: 600 }}>
              WHATSAPP
            </p>
          </a>
        </div>
        <div style={{ width: "25%" }}>
          <a
            href="tel:+919583476804"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              paddingTop: "10px",
              gap: "10px",
              textDecoration: "none",
              backgroundColor: "#944f9f",
            }}
          >
            <img src="/photo/app.svg" alt="" height="25px" width="25px" />
            <p style={{ fontSize: "12px", color: "white", fontWeight: 600 }}>
              CALL
            </p>
          </a>
        </div>
        <div style={{ width: "25%" }}>
          <a
            href="tel:+919583476804"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              paddingTop: "10px",
              gap: "10px",
              textDecoration: "none",
              backgroundColor: "#30327d",
            }}
          >
            <img
              src="/photo/medical-appointment (2).svg"
              alt=""
              height="25px"
              width="25px"
            />
            <p
              style={{
                overflowWrap: "break-word",
                fontSize: "12px",
                color: "white",
                fontWeight: 600,
              }}
            >
              APPOINTMENT
            </p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Sticky;
